import React from 'react';
import type { Nullable } from 'corgi-types';

import { useLocalization } from '../../../providers/LocaleProvider';
import type { Space } from '../../../theme/system-types';
import { BodyRegularBR2 } from '../../Typography';
import type { ProductListVariation, TrackingContext } from '../types/types';
import VariationButton from '../VariationButton';

interface ProductVariationProps {
  sku: string;
  variations: ProductListVariation[];
  productIndex: number;
  visibleProductsCount: number;
  url: string;
  showDelivery: boolean;
  minPrice: Nullable<number>;
  isHorizontalLayout?: boolean;
  trackingContext: TrackingContext;
}

const ProductVariations = ({
  sku,
  variations,
  productIndex,
  visibleProductsCount,
  url,
  showDelivery,
  minPrice,
  isHorizontalLayout,
  trackingContext,
}: ProductVariationProps) => {
  const variationProps = {
    sku,
    variations,
    productIndex,
    visibleProductsCount,
    isHorizontalLayout,
    trackingContext,
    ...(showDelivery && { mb: ['sp_4', null, null, 'sp_6'] as Space }),
  };

  const { t, fc } = useLocalization();

  return (
    <>
      {minPrice && (
        <BodyRegularBR2 mb="sp_4" color="sys.neutral.text.strong">
          {t('h24_variations_from')} {fc(minPrice)}
        </BodyRegularBR2>
      )}
      <VariationButton url={url} {...variationProps} />
    </>
  );
};

export default ProductVariations;
